import React from "react";
import { Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";
const About = () => {
  return (
    <div>
      <Container>
        {/* <Slide left > */}
        <Row className="mt-5">
          <Col md={5}>
            {/* <GreetingLottie animationPath="/lottie/coding.json" /> */}

            <Slide left>
              <lottie-player
                src="https://assets5.lottiefiles.com/packages/lf20_iv4dsx3q.json"
                background="transparent"
                speed="1"
                style={{ width: "100%", height: "90%" }}
                loop
                autoplay
              ></lottie-player>
            </Slide>
          </Col>

          <Col md={7}>
            <Fade duration={3000}>
            <p className="home-about-body">
  Hi, I’m <b className="purple">Prashant Malviya</b> — a{" "}
  <b className="purple">software engineer</b> currently working at a startup,
  focused on building real-world applications.
  <br />
  <br />
  I strongly believe that{" "}
  <b className="purple">
    good engineering is about problem-solving, not just tools
  </b>.
  Given a problem, I enjoy breaking it down, understanding the requirements,
  and learning whatever tech stack is needed to build a reliable solution.
  <br />
  <br />
  I have experience working across the stack using{" "}
  <b className="purple">
    Java, JavaScript, TypeScript
  </b>{" "}
  and frameworks like{" "}
  <b className="purple">
    Next.js, React, Node.js
  </b>, and I’ve also been building{" "}
  <b className="purple">Flutter-based mobile applications</b>.
  However, I’m always open to picking up new technologies when the problem
  demands it.
  <br />
  <br />
  I’m passionate about{" "}
  <b className="purple">
    learning by building, writing clean and maintainable code, and applying
    concepts to real-world use cases
  </b>
   {" "}rather than limiting myself to a fixed set of tools.
  <br />
  <br />
  Outside of work, I continuously sharpen my fundamentals, explore new ideas,
  and build projects that help me grow as an engineer and product builder.
</p>


            </Fade>
          </Col>
        </Row>
        {/* </Slide> */}
      </Container>
    </div>
  );
};

export default About;
